import common from './common';
import notice from './notice';
function getParam(data) {
  let url = '';
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`;
  }
  return url ? url.substring(1) : '';
}
/**
 * app
 * 核心全局app方法
 */
const app = {
  checkAccount() {
    if (navigator.general) {
      navigator.general.checkAccount();
    } else {
      this.deviceready(function() {
        navigator.general.checkAccount();
      });
    }
  },
  /**
   * 用新的webview打开页面
   * @param {*} url
   * @param {*} params
   * @param {*} outerChainType 是否为特殊处理外链
   */
  openWeb(url, params, outerChainType = null) {
    if (!url) {
      notice.alert('页面链接不存在');
      return;
    }
    if (params) {
      url += (url.indexOf('?') < 0 ? '?' : '&') + getParam(params);
    }
    if (common.isApp) {
      let hrefs = '';
      if (url.indexOf('fqtd://') == -1) {
        hrefs = 'fqtd://web?url=' + encodeURIComponent(url);
      } else {
        hrefs = url;
      }

      if (outerChainType) {
        hrefs += '&outerChainType=partner';
      }
      this.router({ url: hrefs });
    } else {
      location.href = url;
    }
  },
  // 打开微信
  openWechat() {
    navigator.wechat.jumpToWechat();
  },
  /**获取用户通讯录
	params
	success 成功回调  [{name:'姓名',phones:'13211111111,15800000000'}] 
	fail 失败回调
	**/
  getAddressBook: function(success, fail) {
    if (navigator.general) {
      navigator.general.getAddressBook(success, fail);
    } else {
      this.deviceready(function() {
        navigator.general.getAddressBook(success, fail);
      });
    }
  },
  //获取用户信息
  getUserInfo: function(success, fail) {
    if (navigator.general) {
      navigator.general.getUserInfo(success, fail);
    } else {
      this.deviceready(function() {
        navigator.general.getUserInfo(success, fail);
      });
    }
  },
  // 获取app相关信息
  getDeviceInfo: function(success, fail) {
    navigator.general.getDeviceInfo && navigator.general.getDeviceInfo(success, fail);
    // navigator.general.getDeviceToken(success,fail);
  },
  //通知app退出登录
  loginOut: function(success, fail) {
    navigator.general.logout(success, fail);
  },
  //检测是否安装支付宝
  getAlipayInstall: function(success, fail) {
    navigator.general.getAlipayInstall(success, fail);
  },

  //获取客服电话
  getServicerPhone: function(success, fail) {
    if (!common.isApp) {
      success('400-8700-100');
      return;
    }
    if (navigator.general) {
      navigator.general.getServicerPhone(success, fail);
    } else {
      this.deviceready(function() {
        navigator.general.getServicerPhone(success, fail);
      });
    }
  },
  //获取字典数据
  getSystemReadDic: function(params, success, fail) {
    if (navigator.general) {
      navigator.general.getSystemReadDic(params, success, fail);
    } else {
      this.deviceready(function() {
        navigator.general.getSystemReadDic(params, success, fail);
      });
    }
  },
  /**
   * type: 1：文字 2：图片
   * router：点击动作
   * content：1：显示的文字 2：图片地址
   * navigator.general.titleMenu(type,router,content);
   *
   */
  titleMenu(content, router, type = 1, success) {
    const params = {
      type,
      router,
      content
    };
    if (navigator.general) {
      navigator.general.titleMenu && navigator.general.titleMenu(params, success);
    } else {
      this.deviceready(function() {
        navigator.general.titleMenu && navigator.general.titleMenu(params, success);
      });
    }
  },
  /**
   * params.type: 0：固定分享图片 1：文字（蓝色） 2：图片
   * params.content：1：显示的文字 2：图片地址
   * success 点击回调
   * navigator.general.titleMenu(params,success);
   *
   */
  titleMenu2(params, success) {
    if (!common.isApp) {
      return;
    }
    if (navigator.general) {
      navigator.general.titleMenu && navigator.general.titleMenu([params], success);
    } else {
      this.deviceready(function() {
        navigator.general.titleMenu && navigator.general.titleMenu([params], success);
      });
    }
  },
  /**
   * 隐藏右上角按钮
   */
  hideTitleMenu() {
    if (common.isApp) {
      navigator.general.hideTitleMenu && navigator.general.hideTitleMenu();
    }
  },
  /**初始化分享*
   * params:{
          router (链接)
          路由：
          wts://share?type=1(分享网页链接)&link=&title=&content=&logo=
          wts://share?type=2(分享图片)&link=(图片链接)
          wts://share?type=3(分享小程序)&link=&title=&content=&logo=&userName=&path=
          wts://share?type=4(文本)&link=&title=&content=&logo=&userName=&path=
      }
      * **/
  // initShare: function (params, success, fail) {
  //   let url = "fqtd://share?type=1"
  //     + "&link=" + encodeURIComponent(params.link)
  //     + "&content=" + encodeURIComponent(params.content)
  //     + "&title=" + encodeURIComponent(params.title)
  //     + "&logo=" + encodeURIComponent(params.logo || (location.origin + "/apps/public/images/share_logo.jpg"));
  //   if (navigator.general) {
  //     navigator.general.rightIcon({ router: url }, success, fail);
  //   } else {
  //     this.deviceready(function () {
  //       navigator.general.rightIcon({ router: url }, success, fail);
  //     })
  //   }
  // },
  initShare(params, success, fail) {
    let url =
      'fqtd://share?type=1' +
      '&link=' +
      encodeURIComponent(params.link) +
      '&content=' +
      encodeURIComponent(params.content) +
      '&title=' +
      encodeURIComponent(params.title) +
      '&logo=' +
      encodeURIComponent(params.logo || location.origin + '/apps/public/images/share_logo.jpg');
    const imgUrl = location.origin + '/apps/public/images/share_btn.png';
    console.log(url);
    console.log(imgUrl);

    if (params.apiPermissionCode) {
      url += '&apiPermissionCode=' + params.apiPermissionCode;
    }
    if (navigator.general) {
      navigator.general.titleMenu([{ type: '2', router: null, content: imgUrl }], () => {
        navigator.general.router({ url }, () => {
          //success
        });
      });
    } else {
      this.deviceready(function() {
        console.log('执行titleMenu');
        navigator.general.titleMenu([{ type: '2', router: null, content: imgUrl }], () => {
          console.log('titleMenu完成');
          navigator.general.router({ url }, () => {
            //success
          });
        });
      });
    }
  },
  toShowTitle(title, callback) {
    if (navigator.general) {
      console.log('执行titleMenu');
      navigator.general.titleMenu([{ type: '1', router: null, content: title }], () => {
        console.log('titleMenu完成');
        callback();
      });
    } else {
      this.deviceready(function() {
        console.log('deviceready...');
        navigator.general.titleMenu([{ type: '1', router: null, content: title }], () => {
          console.log('titleMenu完成');
          callback();
        });
      });
    }
  },
  // 隐藏右上角按钮
  hideRightIcon() {
    if (!common.isApp) {
      return;
    }
    // if (navigator.general) {
    //   console.log('隐藏')
    //   navigator.general.hideRightIcon && navigator.general.hideRightIcon();
    // } else {
    //   this.deviceready(function () {
    //     navigator.general.hideRightIcon && navigator.general.hideRightIcon();
    //   })
    // }
    if (navigator.general) {
      console.log('隐藏');
      navigator.general.titleMenu && navigator.general.titleMenu([], () => {});
    } else {
      this.deviceready(function() {
        navigator.general.titleMenu && navigator.general.titleMenu([], () => {});
      });
    }
  },
  // 打开分享面板
  openSharePanel(params, success, fail) {
    var url =
      'fqtd://share?type=1&title=' +
      encodeURIComponent(params.title) +
      '&content=' +
      encodeURIComponent(params.content) +
      '&logo=' +
      encodeURIComponent(params.logo) +
      '&link=' +
      encodeURIComponent(params.link);
    if (params.target) {
      url += '&target=' + params.target;
    }
    if (params.apiPermissionCode) {
      url += '&apiPermissionCode=' + params.apiPermissionCode;
    }
    console.log('openSharePanel', url);
    this.router({ url }, success, fail);
  },
  /**
   * 直接拉起分享
   * 海报参数poster={"action":"url","message":"提示","has":"0或1"}
      fqyf://share?type=(必传)&link=(必传)&title=(非必传)&content=(非必传)
      &logo=(非必传)&poster=({"action":"","message":"","has":""},非必传)
      &target=(pyq、wx、dingding，非必传)
   * @param {*} params
   */
  openShare(params, success, fail) {
    let url = 'fqtd://share?type=' + params.type + '&link=' + encodeURIComponent(params.link) + '&target=' + (params.target || 'wx');
    if (params.type == 1) {
      url +=
        '&content=' + encodeURIComponent(params.content) + '&logo=' + encodeURIComponent(params.logo || location.origin + '/apps/public/images/share_logo.jpg');
      if (params.title) {
        url += '&title=' + encodeURIComponent(params.title);
      }
    }
    try {
      if (params.poster) {
        url += '&poster=' + encodeURIComponent(JSON.stringify(params.poster));
      }
    } catch (error) {
      console.log('写入poster参数失败');
    }
    if (params.apiPermissionCode) {
      url += '&apiPermissionCode=' + params.apiPermissionCode;
    }
    console.log('openShare', url);
    navigator.general.router(
      {
        url: url
      },
      success,
      fail
    );
  },
  /**打开微信小程序*
   * params:{
          userName (小程序appid)
          path (小程序页面路径)
          miniProgramType (小程序类型 0:正式版  1:开发版  2:体验版)
      }
      * **/
  openMiniProgram: function(params, success, fail) {
    navigator.wechat.openMiniProgram(params, success, fail);
  },

  /**打开app内置页面*
   * params:{
          url (页面路径)
          title (页面标题  可选参数)
      }
      * **/
  router: function(params, success, fail) {
    if (common.isApp) {
      navigator.general.router(params, success, fail);
    }
  },

  /**关闭当前webview页面*
   * **/
  closeWebView: function() {
    navigator.general.close();
  },

  /**pdf预览*
   * params:{
          url (pdf链接)
          title (页面标题  可选参数)
      }
      * **/
  readPdf: function(params) {
    navigator.general.readPdf(params);
  },
  /**excel预览*
   * params:{
          url (链接)
          title (页面标题  可选参数)
      }
      * **/
  readExcel: function(params) {
    navigator.general.readExcel(params);
  },
  /**下载*
   * params:{
          url (图片链接)
          type (文件类型:image  audio video)
      }
      * **/
  download: function(params) {
    navigator.general.download(params);
  },
  /**
   * arr 图片数组
   * index 图片下标
   * share 分享开关
   */
  readImg(params) {
    const url = `fqtd://browse?images=${encodeURIComponent(JSON.stringify(params.arr))}&position=${params.index}&share=${params.share}`;
    navigator.general.router({
      url: url,
      title: params.title || '预览图片'
    });
  },
  /**打开视频播放*
* params:{
    url (视频链接)
  }
  * **/
  playVideo: function(params, success, fail) {
    navigator.general.playVideo(params, success, fail);
  },

  //视频上传人脸识别
  uploadRecognition: function(success, fail) {
    navigator.general.uploadRecognition(success, fail);
  },

  /**设备初始化*
   *callback
   * **/
  deviceready: function(callback) {
    if (common.isApp) {
      document.addEventListener(
        'deviceready',
        function() {
          console.log('deviceready');
          callback();
        },
        false
      );
    } else {
      callback();
    }
  }
};
export default app;
